import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

// Capture hard failures (helps diagnose Safari-only white screens)
window.addEventListener('error', (e: any) => {
  console.error('[GlobalError]', e?.error || e?.message || e);
});
window.addEventListener('unhandledrejection', (e: any) => {
  console.error('[UnhandledRejection]', e?.reason || e);
});

if (environment.production) {
  enableProdMode();
}

window.onkeydown = (e) => {
  if (e.keyCode == 32 && e.target == document.body) {
    e.preventDefault();
  }
};

console.log('Bootstrapping Angular ...');

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
})
  .then(() => {
    // IMPORTANT:
    // Do NOT remove the app-shell loader here.
    // We'll remove it after the first Router navigation completes in AppComponent.

    // Safety fallback: don't trap users forever if something goes wrong.
    setTimeout(() => (window as any).__ochRemoveAppShellLoader?.(), 15000);

    console.log('Angular initialized successfully!');
  })
  .catch((err) => {
    console.log(err);
    (window as any).__ochRemoveAppShellLoader?.();
  });
